export const selectIsLoading = (state) => state.eulaModal.loader
export const selectMessage = (state) => state.eulaModal.message
export const selectError = (state) => state.eulaModal.error
export const selectIsSuccussful = (state) => state.eulaModal.success
